<template>
  <div>
    <box-header title="天然气">
      <div class="box-header-tab">
        <div @click="changeType('year')" class="tab-item" :class="{'active': type === 'year'}">年视图</div>
        <div @click="changeType('month')" class="tab-item" :class="{'active': type === 'month'}">月视图</div>
        <div @click="changeType('beforeTen')" class="tab-item" :class="{'active': type === 'beforeTen'}">最近十日</div>

        <div class="tab-item active">
          <el-image class="tab-placeholder-img" :src="imgPlan" :preview-src-list="[imgPlan]"/>
          规划图
        </div>
      </div>
    </box-header>

    <div class="box" style="height: 340px;">
      <box-border line></box-border>

      <div class="box-filter">
        <div class="box-count">
          <span class="count-name">总量：</span>
          <span class="count-value">{{ count }}</span>
          <span class="count-unit">方</span>
        </div>

        <div class="box-count">
          <span class="count-name">比亚迪：</span>
          <span class="count-value">{{ bydCount }}</span>
          <span class="count-unit">方</span>
        </div>

        <div class="box-count">
          <span class="count-name">多氟多：</span>
          <span class="count-value">{{ dfdCount }}</span>
          <span class="count-unit">方</span>
        </div>

        <div class="box-count">
          <span class="count-name">广西建工：</span>
          <span class="count-value">{{ gxjgCount }}</span>
          <span class="count-unit">方</span>
        </div>
      </div>

      <div style="display: flex;justify-content: end;">
        <div v-if="type === 'year'" class="box-select">
          <el-select :value="currentYear" @change="changeYear" placeholder="请选择">
            <el-option
                v-for="(year,index) in yearList"
                :key="index"
                :value="year"
                :label="year + '年'"
            >
            </el-option>
          </el-select>
        </div>

        <div v-if="type === 'month'" class="box-select">
          <el-select :value="currentMonth" @change="changeMonth" placeholder="请选择">
            <el-option
                v-for="(month,index) in monthList"
                :key="index"
                :value="month"
                :label="month + '月'"
            >
            </el-option>
          </el-select>
        </div>
      </div>


      <div style="height: 100%;margin-top: 20px;background: rgba(10, 27, 46, .51);">
        <div id="chartGYYQ" class="chart"></div>
      </div>
    </div>


  </div>
</template>

<script>
import BoxHeader from "@/components/BoxHeader/BoxHeader.vue";
import BoxBorder from "@/components/BoxBorder/BoxBorder.vue";
import imgPlan from "@/assets/image/img_plan.jpg";

const yearMonthList = ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"];
export default {
  components: {BoxBorder, BoxHeader},
  data() {
    return {
      chart: null,
      currentYear: "2025",
      monthList: ["12","11","10","9","8","7","6","5", "4", "3", "2", "1"],
      currentMonth: "",
      imgPlan: imgPlan,
      dataList: [],
      yearList: ["2023","2024","2025","2026"],
      currentType: "",
      max: 0,
      bydData:[],
      count:0,
      bydCount:0,
      dfdCount:0,
      gxjgCount:0,
      dfdData:[],
      gxjgData:[],
      type:"beforeTen",
      timer: null
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.chart = this.$echarts.init(document.getElementById("chartGYYQ"));
      this.getData();
    });
  },
  methods: {
    changeType(type){
      this.type = type;
      let time = new Date();
      this.currentMonth  = (time.getMonth() + 1) + "";
      this.getData();
    },
    changeYear(year) {
      this.currentYear = year;
      this.getData();
    },
    changeMonth(month) {
      this.currentMonth = month;
      this.getData();
    },
    getData() {
      this.chart.showLoading({
        text: "加载中...",
        maskColor: "rgba(0,0,0,0)",
        fontSize: 26,
        fontWeight: "bold",
        fontFamily: "Alibaba PuHuiTi",
        textColor: "rgba(211, 238, 254, 1)"
      });

      //年视图
      if(this.type === 'year'){
         this.$api.getNatureGasPowerStatisticsByYear(this.currentYear).then(res=>{
           this.disposeData(res.data);
        })
      }
      //月视图
      if(this.type === 'month'){
        this.$api.getNatureGasPowerStatisticsByMonth(this.currentYear,this.currentMonth).then(res=>{
          this.disposeData(res.data);
        })
      }
      if(this.type === 'beforeTen'){
        const today = new Date();
        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);
        const formattedToday = tomorrow.toISOString().split('T')[0];

        const tenDaysAgo = new Date();
        tenDaysAgo.setDate(tenDaysAgo.getDate() - 10);
        const formattedTenDaysAgo = tenDaysAgo.toISOString().split('T')[0];
        this.$api.getNatureGasPowerByRange({begin: formattedTenDaysAgo,end: formattedToday}).then(res=>{
          this.disposeData(res.data);
        })
      }

    },
    disposeData(sourceData) {
      if(this.type === 'year' || this.type === 'month'){
        if(this.type === "year"){
          this.category = yearMonthList;
        }else{
          this.category = sourceData['BYD'].map(item => item.rq + "日");
        }
        this.bydData = sourceData['BYD'].sort((a,b) => a.rq - b.rq).map(item=>item.today_amount);
        this.dfdData = sourceData['DFD'].sort((a,b) => a.rq - b.rq).map(item=>item.today_amount);
        this.gxjgData = sourceData['GXJG'].sort((a,b) => a.rq - b.rq).map(item=>item.today_amount);
        this.renderChart();
      }
      //最近十日
      else{
        const grouped = sourceData.reduce((acc, item) => {
          const key = item.type;
          if (!acc[key]) {
            acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {});
        let date =  grouped['BYD'].map(item=>item.statistics_date);
        this.category = date.map(item => {
          let day = item.split('-')[2]; // 例如 "13"
          if (day.startsWith("0")) {
            day = day.replace("0", "");
          }
          return `${day}日`; // 转换为 "13日"
        });
        this.bydData = grouped['BYD'].sort((a,b) => a.rq - b.rq).map(item=>item.today_amount);
        this.dfdData = grouped['DFD'].sort((a,b) => a.rq - b.rq).map(item=>item.today_amount);
        this.gxjgData = grouped['GXJG'].sort((a,b) => a.rq - b.rq).map(item=>item.today_amount);
        this.renderChart()
      }
      const mergedArray = [...this.bydData, ...this.dfdData, ...this.gxjgData];
      this.count =  this.$lodash.sum(mergedArray).toFixed(2);
      this.bydCount = this.$lodash.sum(this.bydData).toFixed(2);
      this.dfdCount = this.$lodash.sum(this.dfdData).toFixed(2);
      this.gxjgCount = this.$lodash.sum(this.gxjgData).toFixed(2);
    },
    createColorGradient(colorArr) {
    return {
      type: "linear",
      x: 0,
      x2: 1,
      y: 0,
      y2: 0,
      colorStops: [
        { offset: 0, color: colorArr[0] },
        { offset: 0.5, color: colorArr[0] },
        { offset: 0.5, color: colorArr[1] },
        { offset: 1, color: colorArr[1] }
      ]
     };
    },
    renderChart() {
      this.chart.hideLoading();
      const colorArr1 = ["#F66E67", "#F89E85", "#FBCCB2"];
      const colorArr2 = ["#67A4F6", "#85B0F8", "#B2D0FB"];
      const colorArr3 = ["#67F6A4", "#85F8B0", "#B2FBD0"];


      const color1 = this.createColorGradient(colorArr1);
      const color2 = this.createColorGradient(colorArr2);
      const color3 = this.createColorGradient(colorArr3);

      let options = {
        legend: {
          show: true,
          top: 0,
          itemWidth: 40,
          itemGap: 80,
          lineStyle: {
            width: 10
          },
          textStyle: {
            fontFamily: "Alibaba PuHuiTi",
            padding: 10,
            height: 26,
            fontSize: 24,
            color: "rgba(211, 238, 254, 1)"
          }
        },
        tooltip: {
          show: true,
          trigger: "axis",
          confine: true,
          className: "echarts-tooltip",
          extraCssText: "padding: 20px 30px",
          formatter: function (dataList) {
            let html = `<div class="name" style="font-size: 30px;font-weight: 500">${dataList[0].axisValueLabel}`;
            dataList.forEach(data => {
              html += `<div class='title' style='margin-top: 20px;'>${data.seriesName}</div><div class='value'>${data.value}<span class='unit'>方</span></div>`;
            });
            html += "</div>";
            return html;
          },
          textStyle: {
            fontSize: 30
          }
        },
        grid: {
          top: 50,
          bottom: 30,
          left: 30,
          right: 50,
          containLabel: true
        },
        dataZoom: [{
          type: "inside",
          show: true,
          startValue: 0,
          endValue: 11,
          rangeMode: ["value"],
          zoomLock: true
        }],
        xAxis: {
          type: "category",
          data: this.category,
          splitNumber: 6.5,
          axisLabel: {
            show: true,
            margin: 25,
            interval: 0,
            fontSize: 22,
            fontWeight: "bold",
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, 1)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          boundaryGap: true
        },
        yAxis: {
          type: "value",
          name: "方",
          nameLocation: "end",
          nameGap: 25,
          nameTextStyle: {
            fontSize: 22,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .6)"
          },
          axisLabel: {
            margin: 25,
            fontSize: 24,
            fontFamily: "Alibaba PuHuiTi",
            color: "rgba(211, 238, 254, .8)"
          },
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              width: 1,
              color: "rgba(144, 214, 255, .2)"
            }
          }
        },
        series: [
          {
            name: "比亚迪",
            type: "bar",
            data: this.bydData,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: color1
              }
            },
          },
          {
            name: "多氟多",
            type: "bar",
            data: this.dfdData,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: color2
              }
            },
          },
          {
            name: "广西建工",
            type: "bar",
            data: this.gxjgData,
            barWidth: 20,
            itemStyle: {
              normal: {
                color: color3
              }
            },
          }
        ]
      };
      this.chart.setOption(options);
    }
  }
};
</script>

<style scoped lang="scss">
.box-filter {
  display: flex;
  justify-content: space-between;
  padding: 5px 30px;
  box-sizing: border-box;
  height: 50px;
}

.box-header-tab {
  display: flex;
  flex-direction: row;
  align-items: center;

  .tab-item {
    position: relative;

    .tab-placeholder-img {
      position: absolute;
      z-index: 2;
      top: 0;
      left: 0;
      opacity: 0;
      width: 100%;
      height: 100%;
      cursor: pointer;
    }

    width: 166px;
    height: 60px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    background: url("../../assets/image/bg_tab_un.png");
    color: rgba(161, 197, 234, .7);
    font-size: 30px;
    line-height: 72px;
    font-family: "screen", serif;
    margin-right: 15px;
    cursor: pointer;

    &.active {
      color: #E7F3FF;
      text-shadow: 0 0 1em rgba(82, 163, 255, .56), 0 0 1em rgba(82, 163, 255, .56);
      background: url("../../assets/image/bg_tab_on.png");
    }
  }
}

.box-select {
  width: 200px;

  ::v-deep.el-input {
    font-size: 30px;

    .el-input__inner {
      height: 60px;
      line-height: 60px;
    }
  }
}


.box-count {
  height: 60px;
  line-height: 60px;

  .count-name {
    font-size: 22px;
    color: rgb(181, 228, 255);
  }

  .count-value {
    font-size: 24px;
    color: rgb(86, 237, 255);
    font-family: "screen", serif;
  }

  .count-unit {
    font-size: 15px;
    color: rgba(181, 228, 255, 0.6);
    margin-left: 10px;
  }
}
</style>
